/*
  Rouqe live chat (snippets/rq-chat.liquid).

  Talks only to the Rouqe HUD (Theme settings > Live chat). The visitor gives a first name and email,
  then chats; the conversation is kept in this browser (localStorage) so a refresh or another page
  picks it back up. New messages are fetched every few seconds while the chat is open.
*/
(function () {
  if (window.__rqChatLoaded) return;
  window.__rqChatLoaded = true;

  var roots = Array.prototype.slice.call(document.querySelectorAll('[data-rq-chat]'));
  if (!roots.length) return;
  // A chat box in the page (contact page) wins over the floating button.
  var inline = roots.filter(function (r) { return r.dataset.mode === 'inline'; });
  if (inline.length) {
    roots.forEach(function (r) { if (r.dataset.mode !== 'inline') r.remove(); });
  }
  var root = inline[0] || roots[0];
  var floating = root.dataset.mode === 'float';

  var BASE = (root.dataset.api || '').replace(/\/+$/, '');
  var API = BASE + '/api/site-chat/messages';
  var ORDERS_API = BASE + '/api/site-chat/orders';
  var SUPPORT = root.dataset.supportEmail || 'info@rouqesupport.com';
  var KEY = 'rq-chat:v1';
  var FAST = 3000;
  var SLOW = 9000;

  var $ = function (sel) { return root.querySelector(sel); };
  var panel = $('.rq-chat__panel');
  var startForm = $('[data-rq-chat-start]');
  var convo = $('[data-rq-chat-convo]');
  var log = $('[data-rq-chat-log]');
  var typing = $('[data-rq-chat-typing]');
  var sendForm = $('[data-rq-chat-send]');
  var input = sendForm.querySelector('textarea');
  var who = $('[data-rq-chat-who]');
  var hours = $('[data-rq-chat-hours]');
  var dot = $('[data-rq-chat-dot]');
  var orderBox = $('[data-rq-chat-order]');

  /* ---------- what this browser remembers ---------- */

  var memory = {};
  function load() {
    try { return JSON.parse(window.localStorage.getItem(KEY) || '{}') || {}; } catch (e) { return memory; }
  }
  function save(next) {
    memory = next;
    try { window.localStorage.setItem(KEY, JSON.stringify(next)); } catch (e) { /* private mode: keep it for this page only */ }
  }
  var state = load();
  var seen = {};
  var lastSeq = 0;
  var waiting = false;
  var sending = false;
  var lastActivity = Date.now();
  var timer = null;
  var fallbackTimer = null;
  var toldLocally = false;
  var orderKey = '';
  var orderBusy = false;

  /* ---------- small helpers ---------- */

  function showError(scope, text) {
    var el = scope.querySelector('[data-rq-chat-error]') || scope.parentNode.querySelector('[data-rq-chat-error]');
    if (!el) return;
    el.textContent = text || '';
    el.hidden = !text;
  }

  function request(method, body, query, url) {
    var headers = {};
    if (body) headers['content-type'] = 'application/json';
    if (state.token) headers['x-chat-token'] = state.token;
    return fetch((url || API) + (query || ''), {
      method: method,
      headers: headers,
      body: body ? JSON.stringify(body) : undefined,
      mode: 'cors',
      credentials: 'omit',
      cache: 'no-store',
    }).then(function (res) {
      return res.json().catch(function () { return {}; }).then(function (data) {
        if (!res.ok || !data.ok) {
          var err = new Error(data.error || 'Something went wrong. Please email ' + SUPPORT + '.');
          err.code = data.code || String(res.status);
          throw err;
        }
        return data;
      });
    });
  }

  function atBottom() {
    return log.scrollHeight - log.scrollTop - log.clientHeight < 60;
  }
  function scrollDown() {
    log.scrollTop = log.scrollHeight;
  }

  /** Text with any https links made clickable — built as nodes, never as HTML. */
  function fillText(el, text) {
    var parts = String(text).split(/(https:\/\/[^\s<>"')]+)/g);
    parts.forEach(function (part, i) {
      if (i % 2) {
        var a = document.createElement('a');
        a.href = part;
        a.target = '_blank';
        a.rel = 'noopener nofollow';
        a.textContent = part.replace(/^https:\/\//, '');
        el.appendChild(a);
      } else if (part) {
        el.appendChild(document.createTextNode(part));
      }
    });
  }

  function note(text, id) {
    if (id && seen[id]) return;
    if (id) seen[id] = true;
    var stick = atBottom();
    var p = document.createElement('p');
    p.className = 'rq-chat__note';
    p.textContent = text;
    log.appendChild(p);
    if (stick) scrollDown();
  }

  function bubble(m, pending) {
    if (m.id && seen[m.id]) return null;
    if (m.id) seen[m.id] = true;
    // An order's status and tracking link reads better as a message than as a one-line note.
    var card = m.role === 'system' && m.kind === 'order_card';
    if (m.role === 'system' && !card) {
      if (!m.kind) toldLocally = true;
      note(m.text);
      return null;
    }
    var stick = atBottom() || m.role === 'visitor';
    var wrap = document.createElement('div');
    wrap.className = 'rq-chat__msg rq-chat__msg--' + (m.role === 'visitor' ? 'visitor' : 'team') + (pending ? ' rq-chat__msg--pending' : '');
    var from = document.createElement('p');
    from.className = 'rq-chat__from';
    from.textContent = m.role === 'visitor' ? 'You' : card ? 'Your order' : m.from || 'Rouqe';
    var body = document.createElement('p');
    body.className = 'rq-chat__bubble';
    if (m.role === 'visitor') body.textContent = m.text;
    else fillText(body, m.text);
    wrap.appendChild(from);
    wrap.appendChild(body);
    log.appendChild(wrap);
    if (stick) scrollDown();
    return wrap;
  }

  function setWaiting(on) {
    waiting = !!on;
    typing.hidden = !waiting;
    if (waiting && atBottom()) scrollDown();
  }

  /* ---------- "find my order": postal code, then tap the order ---------- */

  function el(tag, cls, text) {
    var node = document.createElement(tag);
    if (cls) node.className = cls;
    if (text) node.textContent = text;
    return node;
  }

  function orderAction(body, errorEl) {
    if (orderBusy || !state.session) return;
    orderBusy = true;
    orderBox.classList.add('is-busy');
    if (errorEl) errorEl.hidden = true;
    body.session_id = state.session;
    request('POST', body, '', ORDERS_API)
      .then(function (data) {
        orderBusy = false;
        orderBox.classList.remove('is-busy');
        lastActivity = Date.now();
        if (data.order) {
          renderOrder(data.order);
        } else {
          // Picked, skipped, or handed to the team: the finder closes and an answer is on its way.
          renderOrder(null);
          setWaiting(true);
        }
        schedule(200);
      })
      .catch(function (err) {
        orderBusy = false;
        orderBox.classList.remove('is-busy');
        if (err.code === 'expired') return expire();
        if (errorEl) {
          errorEl.textContent = err.message && err.code ? err.message : "That didn't go through. Check your connection and try again.";
          errorEl.hidden = false;
        }
      });
  }

  /** Draws the current step (only when it changes, so nothing they are typing is wiped). */
  function renderOrder(o) {
    if (!orderBox) return;
    var key = !o ? '' : o.step + ':' + (o.orders || []).map(function (x) { return x.name; }).join(',');
    if (key === orderKey) return;
    orderKey = key;
    orderBox.textContent = '';
    orderBox.hidden = !o;
    if (!o) return;
    var stick = atBottom();
    var error = el('p', 'rq-chat__error');
    error.setAttribute('role', 'alert');
    error.hidden = true;
    var skip = el('button', 'rq-chat__link', o.step === 'pick' ? 'None of these' : "It's about something else");
    skip.type = 'button';
    skip.addEventListener('click', function () { orderAction({ action: 'skip' }, error); });

    if (o.step === 'pick') {
      orderBox.appendChild(el('p', 'rq-chat__order-title', 'Which order?'));
      var list = el('ul', 'rq-chat__order-list');
      o.orders.forEach(function (order) {
        var item = el('li');
        var btn = el('button', 'rq-chat__order-choice');
        btn.type = 'button';
        btn.appendChild(el('strong', '', 'Order ' + order.name + ' · ' + order.placed));
        btn.appendChild(el('span', '', [order.items, order.status].filter(Boolean).join(' · ')));
        btn.addEventListener('click', function () { orderAction({ action: 'select', order: order.name }, error); });
        item.appendChild(btn);
        list.appendChild(item);
      });
      orderBox.appendChild(list);
    } else {
      orderBox.appendChild(el('p', 'rq-chat__order-title', 'Find your order'));
      orderBox.appendChild(el('p', 'rq-chat__order-hint', 'Enter the postal or ZIP code it shipped to and we will show your orders.'));
      var form = el('form', 'rq-chat__order-form');
      var field = el('input', 'rq-chat__order-input');
      field.type = 'text';
      field.name = 'postal';
      field.maxLength = 12;
      field.autocomplete = 'postal-code';
      field.placeholder = 'Postal / ZIP code';
      field.setAttribute('aria-label', 'Postal or ZIP code the order shipped to');
      var go = el('button', 'button rq-chat__button', 'Find my order');
      go.type = 'submit';
      form.appendChild(field);
      form.appendChild(go);
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var postal = field.value.trim();
        if (!postal) return field.focus();
        orderAction({ action: 'verify', postal: postal }, error);
      });
      orderBox.appendChild(form);
    }
    orderBox.appendChild(error);
    orderBox.appendChild(skip);
    if (stick) scrollDown();
  }

  /* ---------- which step is showing ---------- */

  function showStart() {
    convo.hidden = true;
    startForm.hidden = false;
    startForm.elements.name.value = state.name || root.dataset.name || '';
    startForm.elements.email.value = state.email || root.dataset.email || '';
    startForm.elements.order.value = state.order || '';
  }

  function showConvo() {
    startForm.hidden = true;
    convo.hidden = false;
    who.textContent = 'Chatting as ' + state.name + ' · ' + state.email;
    if (!log.childNodes.length) note('Hi ' + state.name + ' — how can we help?', 'hello');
  }

  // Outside 8am–8pm Pacific, say when to expect an answer.
  (function afterHours() {
    var text = root.dataset.afterHours;
    if (!text || !hours) return;
    try {
      var h = Number(new Intl.DateTimeFormat('en-US', { timeZone: 'America/Vancouver', hour: 'numeric', hour12: false }).format(new Date())) % 24;
      if (h < 8 || h >= 20) {
        hours.textContent = text;
        hours.hidden = false;
      }
    } catch (e) { /* no time zone support: say nothing */ }
  })();

  /* ---------- fetching new messages ---------- */

  function visible() {
    return !document.hidden && (!floating || root.classList.contains('is-open'));
  }

  function schedule(ms) {
    clearTimeout(timer);
    if (!state.session) return;
    var idle = Date.now() - lastActivity;
    // Nothing for 20 minutes: stop asking until they come back to the chat.
    if (idle > 20 * 60 * 1000 && !waiting) return;
    var next = ms !== undefined ? ms : waiting || idle < 3 * 60 * 1000 ? FAST : SLOW;
    if (!visible()) next = Math.max(next, SLOW);
    timer = setTimeout(poll, next);
  }

  function poll() {
    if (!state.session || sending) return schedule();
    // In a background tab, only keep checking while an answer is still expected.
    if (document.hidden && !waiting) return schedule(SLOW);
    request('GET', null, '?session_id=' + encodeURIComponent(state.session) + '&after=' + lastSeq)
      .then(function (data) {
        var fresh = false;
        (data.messages || []).forEach(function (m) {
          if (m.seq > lastSeq) lastSeq = m.seq;
          if (seen[m.id]) return;
          bubble(m);
          if (m.role !== 'visitor') fresh = true;
        });
        if (fresh) {
          lastActivity = Date.now();
          clearTimeout(fallbackTimer);
          if (floating && !root.classList.contains('is-open') && dot) dot.hidden = false;
        }
        setWaiting(data.waiting);
        renderOrder(data.order || null);
        if (data.status === 'closed') note('This chat has ended. Message us again any time.', 'closed-' + lastSeq);
        schedule();
      })
      .catch(function (err) {
        if (err.code === 'expired') return expire();
        schedule(SLOW);
      });
  }

  function expire() {
    state.session = null;
    state.token = null;
    save(state);
    lastSeq = 0;
    setWaiting(false);
    renderOrder(null);
    note('That chat has expired — your next message starts a new one.');
  }

  /* ---------- sending ---------- */

  function send(text) {
    if (sending) return;
    sending = true;
    showError(sendForm, '');
    var mine = bubble({ role: 'visitor', text: text }, true);
    input.value = '';
    grow();
    var body = state.session
      ? { session_id: state.session, text: text }
      : { name: state.name, email: state.email, order: state.order || undefined, text: text, page: window.location.href, website: startForm.elements.website.value };
    request('POST', body)
      .then(function (data) {
        sending = false;
        if (!data.session_id) {
          // Held back quietly (spam check) — nothing more to do.
          if (mine) mine.classList.remove('rq-chat__msg--pending');
          return;
        }
        if (data.token) {
          state.session = data.session_id;
          state.token = data.token;
          save(state);
        }
        if (data.message) {
          seen[data.message.id] = true;
          if (data.message.seq > lastSeq) lastSeq = data.message.seq;
        }
        if (mine) mine.classList.remove('rq-chat__msg--pending');
        lastActivity = Date.now();
        toldLocally = false;
        setWaiting(true);
        // If we can't reach the server at all, still tell them what happens next.
        clearTimeout(fallbackTimer);
        fallbackTimer = setTimeout(function () {
          if (waiting && !toldLocally) {
            setWaiting(false);
            note("Thanks! We'll email you at " + state.email + ' shortly.');
          }
        }, 110 * 1000);
        schedule(FAST);
      })
      .catch(function (err) {
        sending = false;
        if (mine) mine.remove();
        if (err.code === 'expired') {
          expire();
          input.value = text;
          return;
        }
        input.value = text;
        grow();
        showError(sendForm, err.message && err.code ? err.message : "That didn't send. Check your connection and try again, or email " + SUPPORT + '.');
      });
  }

  function grow() {
    input.style.height = 'auto';
    input.style.height = Math.min(input.scrollHeight + 2, 140) + 'px';
  }

  /* ---------- events ---------- */

  startForm.addEventListener('submit', function (e) {
    e.preventDefault();
    var name = startForm.elements.name.value.trim();
    var email = startForm.elements.email.value.trim();
    var order = startForm.elements.order.value.trim();
    if (!name) {
      startForm.elements.name.focus();
      return showError(startForm, 'Please add your first name.');
    }
    if (!/^[^\s@]+@[^\s@]+\.[a-z]{2,}$/i.test(email)) {
      startForm.elements.email.focus();
      return showError(startForm, 'Please add a valid email so we can reach you.');
    }
    showError(startForm, '');
    state = { name: name, email: email, order: order, session: null, token: null };
    save(state);
    log.textContent = '';
    seen = {};
    lastSeq = 0;
    showConvo();
    input.focus();
  });

  sendForm.addEventListener('submit', function (e) {
    e.preventDefault();
    var text = input.value.trim();
    if (text) send(text);
  });

  input.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && !e.shiftKey && !e.isComposing) {
      e.preventDefault();
      var text = input.value.trim();
      if (text) send(text);
    }
  });
  input.addEventListener('input', grow);
  input.addEventListener('focus', function () {
    lastActivity = Date.now();
    schedule(FAST);
  });

  $('[data-rq-chat-reset]').addEventListener('click', function () {
    clearTimeout(timer);
    clearTimeout(fallbackTimer);
    state = {};
    save(state);
    log.textContent = '';
    seen = {};
    lastSeq = 0;
    setWaiting(false);
    renderOrder(null);
    showStart();
    startForm.elements.name.focus();
  });

  document.addEventListener('visibilitychange', function () {
    if (!document.hidden && state.session) schedule(200);
  });

  Array.prototype.forEach.call(root.querySelectorAll('[data-rq-chat-toggle]'), function (btn) {
    btn.addEventListener('click', function () {
      var open = !root.classList.contains('is-open');
      root.classList.toggle('is-open', open);
      panel.hidden = !open;
      Array.prototype.forEach.call(root.querySelectorAll('[data-rq-chat-toggle][aria-expanded]'), function (b) {
        b.setAttribute('aria-expanded', String(open));
      });
      if (open) {
        if (dot) dot.hidden = true;
        lastActivity = Date.now();
        scrollDown();
        (state.name && state.email ? input : startForm.elements.name).focus();
        schedule(200);
      }
    });
  });

  /* ---------- start ---------- */

  if (state.name && state.email) {
    showConvo();
    if (state.session) poll();
  } else {
    showStart();
  }
})();
